const $ = window.jQuery

export default class WooCheckout {
  static init() {
    WooCheckout.onSelectHour()
    // WooCheckout.overrideDeliveryDate()

    const $shippingCity = $('#shipping_city')
    console.log('getOptGroupValSelected', $shippingCity.val())
    const $textShippingCity = $('<div>').text($shippingCity.val())

    $shippingCity.after($textShippingCity).attr('readonly', true).hide()

    $('#shipping_neighborhood').change(function () {
      // const $option = $('option:selected', this) // get selected option
      // const $optGroup = $option.parent()
      const optGroupVal = WooCheckout.getOptGroupValSelected(this)

      console.log('shipping_neighborhood', optGroupVal)
      $shippingCity.val(optGroupVal)
      $textShippingCity.text(optGroupVal)
    })
  }

  static getOptGroupValSelected(el) {
    const $option = $('option:selected', el) // get selected option
    const $optGroup = $option.parent()

    return $optGroup.attr('label')
  }

  static onSelectHour() {
    $('form.checkout').on(
      'change',
      'select#shipping_delivery_time',
      function () {
        var p = $(this).val()

        console.log('#shipping_delivery_time', p)

        $.ajax({
          type: 'POST',
          url: window.wc_checkout_params.ajax_url,
          data: {
            action: 'woo_select_hour_fee',
            shipping_delivery_time: p,
          },
          success: function (result) {
            $('body').trigger('update_checkout')
            console.log('response: ' + result) // just for testing | TO BE REMOVED
          },
          error: function (error) {
            console.log(error) // just for testing | TO BE REMOVED
          },
        })
      }
    )
  }

  static overrideDeliveryDate() {
    const minDate = new Date()
    $('#shipping_delivery_date').attr(
      'min',
      minDate.toLocaleDateString('en-CA')
    )
  }
}
